// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1jLkt","label":"CategoryService_label__Ohp1M","location":"CategoryService_location__1-3Np"};